import { DEFAULT_LOCALE } from '../config/settings'
import { loadSettings } from '../services/settings'
import type { SupportedLocale } from './locales'
import { dictionaries, ja, en } from './locales/index'
import type { TranslationKey } from './locales/ja'

export function getCurrentLocale(): SupportedLocale {
  try {
    return loadSettings().locale
  } catch {
    return DEFAULT_LOCALE
  }
}

/**
 * 指定したキーに対応する翻訳文字列を取得する。
 * ロケールが指定されない場合は現在の設定を使用する。
 * 指定された言語に翻訳がない場合は英語 (en)、それもなければ日本語 (ja) をフォールバックとして使用する。
 */
export function t(key: TranslationKey, locale = getCurrentLocale()): string {
  const dict = dictionaries[locale]
  if (dict && dict[key]) return dict[key]
  
  // Fallback to English
  if (locale !== 'en' && en[key]) return en[key]
  
  // Fallback to Japanese
  return ja[key]
}

/**
 * プレースホルダー {name} を含む翻訳文字列にパラメータを埋め込む。
 */
export function tx(
  key: TranslationKey,
  params: Record<string, string | number>,
  locale = getCurrentLocale(),
): string {
  return t(key, locale).replace(/\{(\w+)\}/g, (_, name: string) => String(params[name] ?? ''))
}
